module.exports = __webpack_public_path__ + "img/logo.8c7bc28.png";